/** Attribute prefix every PosterMyWall component carries (e.g. `data-pmw-type`). */
export const PMW_ATTRIBUTE_PREFIX = 'data-pmw';

/** Attribute GrapesJS itself stamps on a typed component element. */
export const GJS_TYPE_ATTRIBUTE = 'data-gjs-type';

/** Tag names of the wrappers the native RTE injects, inspected per element (kept when they carry formatting). */
export const RTE_JUNK_WRAPPER_SELECTOR = 'font, span';

/**
 * Inline style properties that carry per-run text formatting worth preserving through a normalize pass.
 * Must cover every style a registered RTE action can emit (see grapesjs-email-maker-plugin/src/rte.ts) —
 * a formatting action whose props are missing here silently drops that formatting on every blur.
 */
export const MEANINGFUL_FORMATTING_STYLE_PROPS = ['color', 'background-color', 'font-weight', 'font-style', 'text-decoration', 'text-decoration-line'] as const;

/** Presentational attributes that make a legacy `<font>` a formatting wrapper (e.g. RTE `foreColor`) rather than junk. */
export const FONT_FORMATTING_ATTRIBUTES = ['color', 'face', 'size'] as const;
